module.exports = {
  "id": "3f2f61d2-9037-4a80-aae4-d141e9c4823e",
  "gtmIds": [
    "GTM-5X7W9WW8",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "languages": [
    "en-US"
  ],
  "website": "https://www.biglittlenine.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}